"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _core = require("../../../services/core");
var _reactSelect = _interopRequireDefault(require("react-select"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Style

// Core

const getLocaleOption = locale => ({
  label: /*#__PURE__*/_react.default.createElement("span", {
    className: "locale-font"
  }, locale.toUpperCase()),
  value: locale
});
var _default = () => {
  const {
    locale,
    update
  } = (0, _react.useContext)(_core.ContextCore);
  const [localesOptions, setLocalesOptions] = (0, _react.useState)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const initializeLocales = async () => {
    const response = await _core._Api.get('/languages');
    if (!response.data || !response.data['hydra:member']) {
      return;
    }
    const newLocales = [];
    response.data['hydra:member'].forEach(language => {
      newLocales.push(getLocaleOption(language.locale));
    });
    setLocalesOptions(newLocales);
  };
  const setLocales = async currentLocale => {
    setLoading(true);
    await _core._Translator.fetch(currentLocale);
    update({
      locale: currentLocale
    });
    setLoading(false);
  };
  (0, _react.useEffect)(() => {
    initializeLocales();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    isDisabled: loading,
    className: "locale-selection",
    value: getLocaleOption(locale),
    options: localesOptions,
    onChange: option => setLocales(option.value)
  }), loading && /*#__PURE__*/_react.default.createElement(_reactstrap.Spinner, {
    color: "primary",
    size: "sm"
  }));
};
exports.default = _default;